import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { tap } from "rxjs/operators";
import { ProviderName } from "../../../account/models/login-response.model";
import { config } from "../../../shared/config";
import { AuthService } from "../../../user/services/auth.service";
import { IncrowdSettings } from "./models/incrowd-settings.model";

Injectable({
    providedIn: 'root'
  })
export class IncrowdAuthService {

    public settings: IncrowdSettings;

    /**
     * Create a instance of the Incrowd integration
     */
    constructor(private http: HttpClient, 
        private authService: AuthService) {
        if (this.settings === undefined) {
            let IncrowdConfig = config.providerSettings.find(x => x.providerId === ProviderName.Incrowd);
            if (IncrowdConfig != undefined && IncrowdConfig.settings != undefined) {
                this.settings = IncrowdConfig.settings as IncrowdSettings;
            }
        }
    }

    /**
     * Will check the the user is logged into Incrowd if they customer is logged in then we will try and log them into the portal
     */
     public logUserInIfLoggedInIncrowd(){ 
        let token = '' // need to get this data 
        let headersList = new HttpHeaders({ 'Content-Type': 'application/json' });

        this.http.post(`${config.baseApiUrl}/api/sso/JWT/validate/56/1`,  `"${token}"`, { headers: headersList })
        .pipe(
            tap((authResponse : any) => {
            if (authResponse) {
                const accessToken = authResponse.tokens.AccessToken;
                this.authService.loginUsingToken(accessToken, authResponse.tokens.RefreshToken, "/");
            }
        })).toPromise();         
    }

   /**
   * Will log the customer out of Incrowd as well as the portal
   */
  logout() {
    let providerTokens: { [name: string]: string | null } = {};
    providerTokens.accessToken = '';  // need to get this data
    
    return this.authService.logout(ProviderName.Incrowd, providerTokens);
  }
    
}